import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/layout'

const TermsPage = () => {
  return (
    <Layout heading="Terms">
      <p>
        Welcome to Jobcast.net the social recruiting service of
        Jobcast Media Inc. (“<strong>Jobcast</strong>”).{' '}
        <strong>Jobcast</strong> provides this app located at{' '}
        <strong>https://app.jobcast.net/dashboard/</strong> (“App”)
        and all App-related services, subject to your compliance with
        the Terms of Service set forth below. Please read this Terms
        of Service (the “Terms of Service” or “Terms”) agreement
        carefully before using the App. By using the App, you agree to
        be bound by the Terms of Service. If you do not agree to these
        Terms of Service, please do not use this App.
      </p>
      <p>
        These Terms of Service comprise a legal contract between you
        (“Member” or “you”) and Jobcast.net, Inc. (“we” “us” and/or
        “Jobcast.net”) and sets forth the terms and conditions
        governing your access to, and use of, the Jobcast.net app
        located at <strong>https://app.jobcast.net/dashboard/</strong>{' '}
        (“App”) and the social recruiting services available on the
        App (the “Services”). This App and the Services are intended
        for use by individuals looking for employment, individuals
        helping their connections find employment and for employers or
        recruiters seeking candidates for employment.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        1. Provision of the Services by Jobcast
      </h2>
      <p>
        1.1 The Jobcast Services are provided “as is” and are not
        fault free. Jobcast gives you no warranty with respect to the
        quality or availability of the Services. Jobcast may change
        the form and nature of the Services from time to time at its
        sole discretion and without prior notice to you.
      </p>
      <p>
        1.2 Jobcast may terminate the Services at any time with a
        one-month notice; during which you may request and obtain a
        copy of the Data.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        2. Fair usage
      </h2>
      <p>
        2.1. Jobcast provides recruiting software which may only be
        used for the purposes of recruiting individuals for real jobs
        in real organizations. You may not use the Jobcast Services to
        advertise fake jobs, collect resumes, promote product and
        services or self-employment opportunities and for any other
        use, which is not in line with any applicable law, regulation
        or generally accepted recruiting practices or guidelines.
      </p>
      <p>
        2.2. Jobcast does not currently place a limit on data storage
        or usage. You should however not seek to store more data than
        is reasonably needed for normal recruiting practices.
      </p>
      <p>
        2.3. You agree not to attempt to access any of the Services by
        any means other than through the interface that is provided by
        Jobcast as well as to not engage in any activity that
        interferes with or disrupts the Services or infringes on
        Jobcast brand and intellectual property.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        3. Add-on Services
      </h2>
      <p>
        3.1. Jobcast is pre-integrated with a number of third party
        Add-On Services. These Add-On Services are provided by third
        part vendors. When you purchase such services through the
        Jobcast platform, the terms of service of those vendors apply
        and you should check them before ordering any Add-On Services.
        Jobcast cannot and will not take any responsibility or any
        liability for Add-On services.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        4. Data Privacy
      </h2>
      <p>
        Effective May 25, 2018, Jobcast has updated its{' '}
        <Link to="/privacy/">Privacy Policy</Link> to reflect our
        ongoing efforts to build our app on a foundation of respect
        for user privacy and our recent work to comply with Europe’s
        new privacy law, the General Data Protection Regulation
        (GDPR). While the GDPR applies specifically to people located
        in European Union member states, we’re implementing product
        changes for all users.
      </p>
      <p>
        4.1. The Data (jobs, resumes,…) that you collect through your
        use of the Jobcast Services is your property. As a Data Owner,
        it is your responsibility to ensure that you store and manage
        personal data (resumes) in accordance with the regulations
        applicable in the appropriate jurisdiction. You are
        responsible for maintaining the confidentiality of passwords
        associated with any account you use to access the Services and
        the Data.
      </p>
      <p>
        4.2. Jobcast does not use or share your Data. We only act as a
        Data Processor and will take reasonable measures to protect
        the data from unauthorized use or access. You hereby agree
        that Jobcast may leverage usage information for reporting
        purposes; such data will always be anonymous and may not
        include any personal data from individuals.
      </p>
      <p>
        4.3. You agree that you are solely responsible for any Data or
        Content that you create, collect, transmit or display while
        using the Services and for the consequences of your actions by
        doing so (including any loss or damage which Jobcast may
        suffer).
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        5. Cookie Policy
      </h2>
      <p>
        5.1. By using the App, you are consenting to Jobcast’s use of
        Cookies as follows:
        <br />
        Jobcast and its advertisers may use various kinds of software
        devices to collect information about Internet use. Small files
        called “cookies” may be attached to the user’s Web browser.
        The user can set the user’s browser to disable cookies, but
        the App may not work properly if the user does so. The App
        uses cookies for a variety of purposes in order to improve
        your online experience, for analytics and for marketing, but
        specifically the App use cookies for the following purposes:
      </p>
      <ul>
        <li>
          Identification: The App uses cookies to identify the user’s
          browser so the App can recognize the user.
        </li>
        <li>
          Analytical Purposes: The App uses cookies to analyze user
          activity in order to improve the App. For example, using
          cookies Jobcast can look at aggregate patterns like the
          average number of job searches that users perform. Jobcast
          can use such analysis to gain insights about how to improve
          the functionality and user experience of the App.
        </li>
        <li>
          Marketing: The App uses cookies from third-party partners
          such as Google and DoubleClick for marketing purposes. These
          Cookies allow Jobcast to display promotional material to you
          on other App you visit across the Internet. Jobcast and
          Google use first-party cookies (such as the Google Analytics
          cookie) and third-party cookies (such as the DoubleClick
          cookie).
        </li>
      </ul>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        6. Limitation of Liability
      </h2>
      <p>
        6.1. Jobcast, its Subsidiaries and Affiliates, and its
        licensors shall not be liable to you for:
      </p>
      <p>
        6.1.1. any indirect or consequential losses which may be
        incurred by you. This shall include any loss of profit
        (whether incurred directly or indirectly), any loss of
        goodwill or business reputation, or any loss of data suffered
        by you;
      </p>
      <p>
        6.1.2. any loss or damage which may be incurred by you as a
        result of:
      </p>
      <ul>
        <li>
          any reliance placed by you on the completeness, accuracy or
          existence of any advertising, or as a result of any
          relationship or transaction between you and any provider of
          Add-on Services;
        </li>
        <li>
          any changes which Jobcast may make to the Services, or for
          any permanent or temporary cessation in the provision of the
          Services (or any features within the Services);
        </li>
        <li>
          the deletion of, corruption of, or failure to store, any
          Content and other communications data maintained or
          transmitted by or through your use of the Services;
        </li>
      </ul>
      <p>
        6.2. The liability of Jobcast under or in relation to the
        subject matter of this agreement, the Terms and of your use of
        the Jobcast Services and Add-on Services shall never exceed $1
        regardless of where such liability arises from.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        7. Intellectual Property
      </h2>
      <p>
        7.1. Jobcast gives you a personal, worldwide, non-assignable
        and non-exclusive license to use the software provided to you
        by Jobcast as part of the Services. This license is for the
        sole purpose of enabling you to use and enjoy the benefit of
        the Services as provided by Jobcast, in the manner permitted
        by the Terms.
      </p>
      <p>
        7.2. You may not (and you may not permit anyone else to) copy,
        modify, create a derivative work of, reverse engineer,
        decompile or otherwise attempt to extract the source code of
        the Software or any part thereof.
      </p>
      <p>
        7.3. Unless you have agreed otherwise in writing with Jobcast,
        nothing in the Terms gives you a right to use any of Jobcast
        trade names, trademarks, service marks, logos, domain names,
        and other distinctive brand features.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        8. General Terms
      </h2>
      <p>
        8.1. The Terms constitute the entire agreement between you and
        Jobcast and govern your use of the Services. Jobcast may make
        changes to the Terms from time to time. Your use of the
        Services after the date of the changes constitutes acceptance
        of the updated Terms.
      </p>
      <p>
        8.2. The Terms, and your relationship with Jobcast under the
        Terms, shall be governed by the laws of the Province of
        British Columbia. You and Jobcast agree to submit to the
        exclusive jurisdiction of the courts of the Province of
        British Columbia to resolve any legal matter arising from the
        Terms.
      </p>
      <h2 style={{ fontWeight: 'bold', fontSize: '110%' }}>
        9. Refund/Returns
      </h2>
      <p>
        9.1. Jobcast offers a monthly subscription service and users
        can cancel their subscription at any time. Refunds will only
        be provided if Jobcast is found in breach of these Terms.
      </p>
      <div
        style={{
          textAlign: 'center',
          fontSize: '0.8em',
          marginTop: '10px',
        }}
      >
        Questions? We encourage you to{' '}
        <Link to="/contact-us/">contact us</Link>.
      </div>
    </Layout>
  )
}

export default TermsPage
